import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const CTASection = ({ onOpenContactForm, heading, paragraph, buttonText }) => {
  const section = useScrollAnimation({ threshold: 0.2 });

  return (
    <section data-testid="cta-section" ref={section.ref} className="relative py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0 bg-[#101423]" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-500/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] rounded-full bg-indigo-500/5 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div className={`max-w-3xl mx-auto text-center scroll-fade-up ${section.isVisible ? 'scroll-visible' : ''}`}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter leading-tight mb-6 uppercase text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {heading}
          </h2>
          <p className="text-base text-slate-300 leading-relaxed mb-10 max-w-2xl mx-auto">
            {paragraph}
          </p>
          <Button
            data-testid="cta-section-button"
            onClick={onOpenContactForm}
            size="lg"
            className="bg-gradient-to-r from-amber-500 to-orange-600 text-white hover:from-amber-600 hover:to-orange-700 font-bold px-10 py-6 text-base rounded-md uppercase tracking-wider btn-shine shadow-lg shadow-amber-500/20"
          >
            {buttonText}
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
